import React, { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: "button" | "submit" | "reset";
  classes?: string
}

const Button: React.FC<ButtonProps> = ({ type, children, classes, ...rest }) => {
  return (
    <button
      // className={`text-center   bg-primary-red-button text-white hover:bg-primary-red-button-hover  rounded-lg py-2 px-6 ${classes}`}
      className={`text-center  px-6  rounded-full py-2   ${classes} `}

      type={type}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
